/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationBoxItem } from './AdminStockAdjustLocationBoxItem';
import {
    AdminStockAdjustLocationBoxItemFromJSON,
    AdminStockAdjustLocationBoxItemFromJSONTyped,
    AdminStockAdjustLocationBoxItemToJSON,
    AdminStockAdjustLocationBoxItemToJSONTyped,
} from './AdminStockAdjustLocationBoxItem';

/**
 * 
 * @export
 * @interface AdminStockAdjustLocationDetailResVo
 */
export interface AdminStockAdjustLocationDetailResVo {
    /**
     * 仓库ID
     * @type {number}
     * @memberof AdminStockAdjustLocationDetailResVo
     */
    warehouseId?: number;
    /**
     * 仓库名称（国际化）
     * @type {string}
     * @memberof AdminStockAdjustLocationDetailResVo
     */
    warehouseName?: string;
    /**
     * 
     * @type {Array<AdminStockAdjustLocationBoxItem>}
     * @memberof AdminStockAdjustLocationDetailResVo
     */
    boxes?: Array<AdminStockAdjustLocationBoxItem>;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationDetailResVo interface.
 */
export function instanceOfAdminStockAdjustLocationDetailResVo(value: object): value is AdminStockAdjustLocationDetailResVo {
    return true;
}

export function AdminStockAdjustLocationDetailResVoFromJSON(json: any): AdminStockAdjustLocationDetailResVo {
    return AdminStockAdjustLocationDetailResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'boxes': json['boxes'] == null ? undefined : ((json['boxes'] as Array<any>).map(AdminStockAdjustLocationBoxItemFromJSON)),
    };
}

export function AdminStockAdjustLocationDetailResVoToJSON(json: any): AdminStockAdjustLocationDetailResVo {
    return AdminStockAdjustLocationDetailResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationDetailResVoToJSONTyped(value?: AdminStockAdjustLocationDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'boxes': value['boxes'] == null ? undefined : ((value['boxes'] as Array<any>).map(AdminStockAdjustLocationBoxItemToJSON)),
    };
}

